/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface HostNameAndTldAndApiCurrencyCodeApiKeyData
 */
export interface HostNameAndTldAndApiCurrencyCodeApiKeyData {
    /**
     * 
     * @type {string}
     * @memberof HostNameAndTldAndApiCurrencyCodeApiKeyData
     */
    hostName?: string;
    /**
     * 
     * @type {string}
     * @memberof HostNameAndTldAndApiCurrencyCodeApiKeyData
     */
    tld?: string;
    /**
     * 
     * @type {string}
     * @memberof HostNameAndTldAndApiCurrencyCodeApiKeyData
     */
    currencyCode?: string;
    /**
     * 
     * @type {string}
     * @memberof HostNameAndTldAndApiCurrencyCodeApiKeyData
     */
    apiKey?: string;
}

/**
 * Check if a given object implements the HostNameAndTldAndApiCurrencyCodeApiKeyData interface.
 */
export function instanceOfHostNameAndTldAndApiCurrencyCodeApiKeyData(value: object): value is HostNameAndTldAndApiCurrencyCodeApiKeyData {
    return true;
}

export function HostNameAndTldAndApiCurrencyCodeApiKeyDataFromJSON(json: any): HostNameAndTldAndApiCurrencyCodeApiKeyData {
    return HostNameAndTldAndApiCurrencyCodeApiKeyDataFromJSONTyped(json, false);
}

export function HostNameAndTldAndApiCurrencyCodeApiKeyDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): HostNameAndTldAndApiCurrencyCodeApiKeyData {
    if (json == null) {
        return json;
    }
    return {
        
        'hostName': json['hostName'] == null ? undefined : json['hostName'],
        'tld': json['tld'] == null ? undefined : json['tld'],
        'currencyCode': json['currencyCode'] == null ? undefined : json['currencyCode'],
        'apiKey': json['apiKey'] == null ? undefined : json['apiKey'],
    };
}

export function HostNameAndTldAndApiCurrencyCodeApiKeyDataToJSON(json: any): HostNameAndTldAndApiCurrencyCodeApiKeyData {
    return HostNameAndTldAndApiCurrencyCodeApiKeyDataToJSONTyped(json, false);
}

export function HostNameAndTldAndApiCurrencyCodeApiKeyDataToJSONTyped(value?: HostNameAndTldAndApiCurrencyCodeApiKeyData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'hostName': value['hostName'],
        'tld': value['tld'],
        'currencyCode': value['currencyCode'],
        'apiKey': value['apiKey'],
    };
}

